import React, { useState } from "react";
import * as XLSX from "xlsx";

export default function ExcelImporter({ onDataImported, onRemoveFile }) {
  const [fileName, setFileName] = useState("");

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      // Map Arabic column names -> English fields used in your app
      const mappedData = jsonData.map((row) => ({
        Product: row["اسم المنتج"] || "",
        Price: row["سعر بيع"] || 0,
        Currency: "EGP", // default
        Qty: 1,
        SKU: row["باركود"] || "",
        Unit: row["الوحده"] || "",
      }));

      onDataImported(mappedData);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleRemoveFile = () => {
    setFileName(null);
    if (onRemoveFile) onRemoveFile();
  };

  return (
    <div className="bg-white rounded-2xl shadow p-4 space-y-3">
      <h2 className="font-semibold text-lg">استيراد المنتجات من Excel</h2>
      <p className="text-sm text-neutral-600">
        قم برفع ملف اكسل يحتوي على الأعمدة: (اسم المنتج، سعر بيع، كميه، باركود، الوحده).
      </p>

      <label className="flex flex-col items-center justify-center w-full h-28 border-2 border-dashed border-neutral-300 rounded-xl cursor-pointer hover:border-neutral-500 transition">
        <span className="text-sm text-neutral-600">
          {fileName ? `📄 ${fileName}` : "اضغط لرفع ملف Excel"}
        </span>
        <input
          type="file"
          accept=".xlsx, .xls, .csv"
          onChange={handleFileUpload}
          className="hidden"
        />
      </label>

      {fileName && (
        <div className="text-xs text-green-600">
          ✅ تم تحميل الملف بنجاح
        </div>
      )}

      <div className="text-xs text-neutral-500">
        <button
          onClick={handleRemoveFile}
          className="underline"
        >
          ازالة الملف
        </button>
      </div>
    </div>
  );
}
